import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { CONFIG } from "../../config/constant";
import Header from "../../component/Header";
import { useSelector } from "react-redux";
import "./index.scss";

const Search = (props) => {
  const navigate = useNavigate();
  const [defaultLanguage, setDefaultLanguage] = useState('en');
  const [query, setQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    if (localStorage.getItem('language')) {
      setDefaultLanguage(localStorage.getItem('language'));
    }
  }, []);

  async function searchContent() {
    if (!query) {
      return;
    }
    const url = CONFIG.BASE_URL + `app/search?language=${defaultLanguage}&query=${query}&platform=web`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      setSearchResult(response);
    }
  }

  const keyDownHandler = (e) => {
    const key = e.keyCode;
    switch (key) {
      case 13:
        searchContent();
        break;
    }
  }

  const clickHandler = (e, item) => {

  };

  return (
    <Fragment>
      <div className="search-page">
        <Header />
        <div className="search-page-content">
          <div className="search-section">
            <div className="input-wrapper">
              <input type="text" className="search-text" placeholder="search content" value={query} onChange={e => setQuery(e.target.value)} onKeyDown={keyDownHandler} />
              <span className="search-icon" onClick={(e) => searchContent()}></span>
            </div>
          </div>
          <div className="search-list-container">
            {searchResult?.map(item => {
              return (<div className="search-item" style={{ backgroundImage: `URL('${item?.thumbnail}')` }} onClick={(e) => clickHandler(e, item)}></div>)
            })}
          </div>

        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default Search;
